import { useMemo } from 'react';
import { useCart } from './context/cart';
import { useGiftCardCart } from './context/giftCardCart';
import { useMerchant } from './context/merchant';
import { useServiceType } from './context/serviceType';

export const useDeliveryPlacementConditions = () => {
  const { deliveryMinimumItemCost, deliveryOrderNoFeesAmount, deliveryFee } = useMerchant();
  const { isDelivery } = useServiceType();
  const { subtotal: cartSubtotal } = useCart();
  const { subtotal: giftCardSubtotal } = useGiftCardCart();

  const subtotal = cartSubtotal + giftCardSubtotal;
  const noDeliveryFee = !deliveryFee || deliveryFee === 0;

  const isBelowMinimumDeliveryAmount = useMemo(() => {
    return subtotal < deliveryMinimumItemCost;
  }, [deliveryMinimumItemCost, subtotal]);

  const disableDeliverySubmit = useMemo(
    () => isDelivery && isBelowMinimumDeliveryAmount,
    [isBelowMinimumDeliveryAmount, isDelivery]
  );

  const isBelowFreeDelivery = useMemo(() => {
    if (noDeliveryFee) return false;

    return subtotal < deliveryOrderNoFeesAmount;
  }, [deliveryOrderNoFeesAmount, noDeliveryFee, subtotal]);

  const isFreeDelivery = useMemo(() => {
    if (noDeliveryFee) return false;

    return subtotal >= deliveryOrderNoFeesAmount;
  }, [deliveryOrderNoFeesAmount, noDeliveryFee, subtotal]);

  const amountLeftForFreeDelivery = useMemo(() => {
    if (isFreeDelivery || noDeliveryFee) return 0;

    return deliveryOrderNoFeesAmount - subtotal;
  }, [deliveryOrderNoFeesAmount, isFreeDelivery, noDeliveryFee, subtotal]);

  return {
    isBelowMinimumDeliveryAmount,
    disableDeliverySubmit,
    isBelowFreeDelivery,
    isFreeDelivery,
    amountLeftForFreeDelivery
  };
};
